<template>
  <v-text-field
      variant="outlined"
      hide-details="auto"
      required
  />
</template>
